import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  students: [],
};

export const studentsSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    studentsFetched: (state, action) => {
      state.students = action.payload;
    },
    studentsUpdated: (state, action) => {
      state.students = action.payload;
    },
  },
});

export const { studentsFetched, studentsUpdated } = studentsSlice.actions;

export default studentsSlice.reducer;
